module.exports = __webpack_public_path__ + "static/media/logo.70302c89.png";